import { useMemo, useState } from 'react';
import {
  List,
  TextField,
  EmailField,
  FunctionField,
  useGetList,
  useTranslate,
} from 'react-admin';
import { CustomDatagrid, CrudListActions, RowActionsMenu } from '@/components/common';
import { compactListSx } from '@/components/common/compactListSx';
import {
  CollapsibleFilterPanel,
  FilterExpandContext,
} from '@/components/common/CollapsibleFilterPanel';
import { CustomTextInputFilter } from '@/components/common/CustomFilters';

export const ClientList = () => {
  const translate = useTranslate();
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const filterExpandValue = useMemo(
    () => ({ expanded: filtersExpanded, setExpanded: setFiltersExpanded }),
    [filtersExpanded]
  );

  const { data: plans } = useGetList('plans', {
    pagination: { page: 1, perPage: 500 },
    sort: { field: 'plan_id', order: 'ASC' },
  });
  const planNames = useMemo(() => {
    const map: Record<number, string> = {};
    (plans ?? []).forEach((plan: any) => {
      map[plan.plan_id] = plan.name;
    });
    return map;
  }, [plans]);

  const filters = useMemo(
    () => [
      <CollapsibleFilterPanel key="filters" source="_cfp" alwaysOn alwaysVisibleCount={0}>
        <CustomTextInputFilter
          source="q"
          label={translate('common.filters.search', { _: 'Buscar' })}
          alwaysOn
        />
      </CollapsibleFilterPanel>,
    ],
    [translate]
  );

  return (
    <FilterExpandContext.Provider value={filterExpandValue}>
      <List
        sx={compactListSx}
        filters={filters}
        actions={<CrudListActions exportColumns={['full_name', 'email', 'company_name', 'contact_no', 'plan_id', 'status']} />}
        sort={{ field: 'user_id', order: 'DESC' }}
        exporter={false}
      >
        <CustomDatagrid primarySource="full_name" secondarySource="email" bulkActionButtons={false}>
          <RowActionsMenu label="" sortable={false} />
          <TextField source="full_name" />
          <EmailField source="email" />
          <TextField source="company_name" />
          <FunctionField
            source="plan_id"
            render={(record: any) => planNames[record?.plan_id] ?? record?.plan_id ?? ''}
            sortable={false}
          />
          <FunctionField
            source="status"
            render={(record: any) =>
              record?.status === 1
                ? translate('common.status.active', { _: 'Activo' })
                : translate('common.status.inactive', { _: 'Inactivo' })
            }
          />
        </CustomDatagrid>
      </List>
    </FilterExpandContext.Provider>
  );
};

export default ClientList;
